/* eslint-disable react/prop-types */
import React from 'react';
import { checkIfLoggedIn } from '@blaze-cms/core-auth-ui';
import UserNavigation from './UserNavigation';

const UserMenuMobile = ({ className, toggleSubmenu, CLASSES, section, openSubmenu }) => {
  const { isLoggedIn } = checkIfLoggedIn();

  if (!isLoggedIn) return '';

  return (
    <li className={`${className} bi-channel--vbs`}>
      <div className={CLASSES.MAIN_MENU_ITEM_TOGGLER} onClick={() => toggleSubmenu(section)}>
        USER
      </div>

      <div
        className={`${CLASSES.MAIN_MENU_SUBITEMS} bi-channel--vbs submenu-open-${
          openSubmenu === section
        }`}>
        <UserNavigation
          className="header__main-menu__subitems-block"
          subMenuClass="header__main-menu__subitem"
        />
      </div>
    </li>
  );
};

export default UserMenuMobile;
